export default "__VITE_ASSET__CujruVvN__"